import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "i18n";
import PageHeader from "../Common/PageHeader/PageHeader";
import { ICONS } from "../Common/Icons";
import styles from "./CollaboratorList.local.scss";
import CollaboratorList from "./CollaboratorList";
import { fetchCollaborators } from "Thunks";
import {
  setSearchNameCollaborator,
  setCollaboratorPaginationPage,
  setCurrentNavPage,
  setYearFilterCollaborators
} from "Actions";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import TTPPaginator from "../Common/TTPPaginator";
import classnames from "classnames";
import { Select } from "antd";
import { getUrlProperties } from "Utils";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

class CollaboratorListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAssociationModal: false,
      rolesActive: ["GD"],
      rolesValues: ["manager"]
    };
  }

  componentDidMount() {
    const { dispatch, yearFilter, synchro } = this.props;

    let year = yearFilter;
    const params = getUrlProperties();
    if (params.has("year")) {
      year = params.get("year");
      dispatch(setYearFilterCollaborators(year));
    }
    dispatch(setCurrentNavPage("COLLABORATORS_LIST"));

    if (synchro !== null) this.handleSearchInputChange("");
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchWord, dispatch, yearFilter, synchro } = this.props;
    const { rolesActive, rolesValues } = this.state;
    if (
      prevState.rolesActive !== rolesActive ||
      prevProps.synchro !== synchro
    ) {
      dispatch(setCollaboratorPaginationPage(1));
      dispatch(fetchCollaborators(searchWord, rolesValues, yearFilter));
    }
  }

  handleSearchInputChange = word => {
    const { dispatch, yearFilter } = this.props;
    const { rolesValues } = this.state;
    let year = yearFilter;
    const params = getUrlProperties();
    if (params.has("year")) {
      year = params.get("year");
    }
    dispatch(setCollaboratorPaginationPage(1));
    dispatch(setSearchNameCollaborator(word));
    dispatch(fetchCollaborators(word, rolesValues, year));
  };

  handleCollaboratorListPageChange = ({ selected }) => {
    const { searchWord, dispatch, yearFilter } = this.props;
    const { rolesValues } = this.state;
    dispatch(setCollaboratorPaginationPage(selected + 1));
    dispatch(fetchCollaborators(searchWord, rolesValues, yearFilter));
  };
  handleFilterByRoles = role => {
    const { rolesActive, rolesValues } = this.state;
    this.setState({
      ...this.state,
      rolesValues:
        role.key !== "tout"
          ? rolesValues.filter(roles => roles === role.value).length > 0
            ? rolesValues.filter(function(roles) {
                return roles !== role.value;
              })
            : [...rolesValues, role.value]
          : [],
      rolesActive:
        role.key !== "tout"
          ? rolesActive.filter(roles => roles === role.key).length > 0
            ? rolesActive.filter(function(roles) {
                return roles !== role.key;
              })
            : [...rolesActive, role.key]
          : []
    });
  };

  handleChangeYear = value => {
    const { dispatch, searchWord } = this.props;
    const { rolesValues } = this.state;
    dispatch(setCollaboratorPaginationPage(1));
    dispatch(setSearchNameCollaborator(searchWord));
    dispatch(fetchCollaborators(searchWord, rolesValues, value));
    dispatch(setYearFilterCollaborators(value));

    const url = new URL(window.location);
    url.searchParams.set("year", value);
    window.history.replaceState({}, "", url);
  };
  renderPaginate() {
    let { error, paginationPage, pageSize, nbResult } = this.props;
    if (error != null && error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleCollaboratorListPageChange}
        pageSize={pageSize}
        nbResult={nbResult}
        paginationPage={paginationPage}
      />
    );
  }
  render() {
    const {
      fetching,
      items,
      fetched,
      yearFilter,
      withoutHeader,
      statusCounts
    } = this.props;
    const { rolesActive } = this.state;
    const roles = [
      { key: "GD", value: "manager" },
      { key: "GE", value: "encodingManager" },
      { key: "SE", value: "encodingSupervisor" },
      { key: "scanOp", value: "scanOperator" },
      { key: "supervisor", value: "supervisor" }
    ];
    let { synchro } = this.props;
    let defaultYear = yearFilter;
    let yearSelector;
    const params = getUrlProperties();
    if (params.has("year")) {
      defaultYear = params.get("year");
    }

    const years = [1, 2, 3, 4];
    const { Option } = Select;
    if (synchro) {
      yearSelector = (
        <Select
          defaultValue={defaultYear}
          style={{ width: 105, marginLeft: "2rem", color: "white" }}
          onChange={this.handleChangeYear}
          id={"select_ant"}
        >
          {years.map((year, i) => {
            return (
              <Option value={new Date().getFullYear() - i}>
                {new Date().getFullYear() - i}
              </Option>
            );
          })}
        </Select>
      );
    } else {
      yearSelector = (
        <Select
          defaultValue={defaultYear}
          style={{ width: 180, marginLeft: "5rem", color: "white" }}
          onChange={this.handleChangeYear}
          id={"select_ant"}
        >
          {years.map((year, i) => {
            return (
              <Option value={new Date().getFullYear() - i}>
                {new Date().getFullYear() - i}
              </Option>
            );
          })}
        </Select>
      );
    }
    return (
      <div style={{ paddingLeft: withoutHeader ? "50px" : "" }}>
        {inIframe() === false && (
          <div
            style={{
              marginBottom: "10px"
            }}
          >
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <PageHeader
          header={_("collaboratorList")}
          subHeader={_("collaboratorListSubHeader")}
          icon={ICONS.Collaborator}
        />
        <div className={styles.filters}>
          <div className={styles.roles}>
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex"
              }}
            >
              {yearSelector}
            </div>
            {synchro == 1 && (
              <div
                className={classnames(
                  styles.roles_butt,
                  rolesActive.length === 0 ? styles.active : ""
                )}
                style={{ marginLeft: " 1.6rem" }}
                onClick={() =>
                  this.handleFilterByRoles({ key: "tout", value: null })
                }
              >
                <p>
                  {_("all")} (
                  {statusCounts && statusCounts["ALL"]})
                </p>
              </div>
            )}
            {synchro == 1 &&
              roles.map((item, i) => {
                return (
                  <div
                    className={classnames(
                      styles.roles_butt,
                      rolesActive.filter(role => role === item.key).length > 0
                        ? styles.active
                        : ""
                    )}
                    onClick={() => this.handleFilterByRoles(item)}
                  >
                    <p>
                      {item.key} ({statusCounts && statusCounts[item.key]})
                    </p>
                  </div>
                );
              })}
          </div>

          <div className={styles.filters_search}>
            <TTPFilterHorizontalBar
              HideButton={true}
              filters={[]}
              searchPlaceholder={_("searchByName")} //  ref={this.child}
              //  customAddOn={this.renderCategoriesSelect()}
              //  customAddOnFirst={true}
              handleSearchInputChange={this.handleSearchInputChange}
              fetching={
                fetching //  cssClass={classnames(styles.searchClass, "medium-12")}
              }
            />
          </div>
        </div>

        <div>
          <div className={styles.container}>
            {fetching ? (
              <div className={styles.ripple_loading}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            ) : (
              <CollaboratorList items={items} synchro={synchro} />
            )}
          </div>
        </div>
        <div style={{ margin: "4% 0 4% 0" }}>
          {fetching ? (
            ""
          ) : items && items.length && fetched ? (
            this.renderPaginate()
          ) : (
            <div className="row pagination" />
          )}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.collaboratorList.fetching,
  fetched: state.collaboratorList.fetched,
  items: state.collaboratorList.items,
  nbResult: state.collaboratorList.nbResult,
  paginationPage: state.collaboratorList.paginationPage,
  pageSize: state.collaboratorList.pageSize,
  error: state.collaboratorList.error,
  searchWord: state.collaboratorList.searchWord,
  yearFilter: state.collaboratorList.yearFilter,
  synchro: state.fiduciary.data && state.fiduciary.data.synchro,
  withoutHeader: state.auth.withoutHeader,
  currentNavPage: state.params.currentNavPage,
  statusCounts: state.collaboratorList.statusCounts
});

export default connect(mapStateToProps)(CollaboratorListPage);



// WEBPACK FOOTER //
// ./src/components/Collaborator/CollaboratorListPage.js